import React from "react";
import get from "lodash/get";
import map from "lodash/map";
import { withTranslation } from "react-i18next";
import fromIntensity from "../../../../utils/get-zone";
import find from "lodash/find";
import convert from "convert-units";
import some from "lodash/some";
import range from "lodash/range";
import ToolTip from "../../../../parts/tooltip";
import round from "lodash/round";
import submit from "submit-form";
import isEqual from "lodash/isEqual";
import moment from "moment";
import Select from "react-select";
import ParameterQuickEditInput from "../../../../parts/inputs/parameter-quick-edit-input";
import NewExerciseLineParameters from "./NewExerciseLineParameters";
import AthleteExerciseNote from "./AthleteExerciseNote";
import ActualResultsComponent from "../../calendar/components/ActualResultsComponent";
import {
  parameterName,
  mapParameter,
} from "../../../../parts/other-exercise/CustomParametersSets";
import getStatus from "../../../../utils/status-exercises";
import convertToRiR from "../../../../utils/converters/convert-intensity";

import { PARAMETER_OPTIONS } from "../../../../constants";
import { repsValue } from "../../../../utils/reps-range";
import { hasSetsReps } from "../../../../utils/actuals";

const { FREEFORM, LOAD, RPE, RPEAMRAP, REPS } = PARAMETER_OPTIONS;

class ExerciseLineItem extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { t } = this.props;
    const {
      handleQuickEditChange,
      _handleOpenAddSet,
      _handleCloseAddSet,
      _handleNewSetChange,
      _handleSaveNewSet,
      _handleNewMovementChange,
      set,
      newSet,
      setIndex,
      activeExercise,
      isProgramEditor,
      fromMetric,
      activeUser,
      withWeight,
      loadInputs,
      intensityInputs,
      localLoadInputs,
      localIntensityInputs,
      isQuickEditOpen,
      isAddingSet,
      currentRow,
      units,
      newMovement,
      setLength,
      activeContextUser,
      activeExerciseNotes,
      exercises,
      _handleSaveNewSetForOther,
      prevHandleReorder,
      nextHandleReorder,
      isFirst,
      isLast,
      isAnySetCompleted,
      prefix,
      expanded,
      toggleExpanded,
      intensityMeasure,
      isRiR,
    } = this.props;

    const hideVelocitySettings =
      activeContextUser.hideVelocitySettings !== false;

    const isAssistant = activeExercise.type === "assistant";
    const isPrimary = activeExercise.type === "primary";
    const isComplex = !!activeExercise.complex;
    // gets primary repmax of the exercise if exercise type is primary else
    // if secondary, use secondary rm, else if assistant just use active user's squat (RM doesn't really matter for assistant)
    // if all else fails, default to 0

    const fromRM =
      isPrimary && !isComplex
        ? `repMaximums.${activeExercise.primary}`
        : "secondaryRepMaximum";

    let defaultRepMax = get(
      activeExercise,
      fromRM,
      get(activeUser, "repMaximums.squat", 0)
    );

    // There were a bug after duplicating the exercises of a cycle, this handle it
    if (fromRM === "secondaryRepMaximum" && defaultRepMax === 0) {
      defaultRepMax = get(
        activeExercise,
        `repMaximums.${activeExercise.primary}`
      );
    }

    if (activeExercise.type == "secondary") {
      const movement =
        find(activeUser.exerciseLibrary, {
          movement: activeExercise.secondary,
        }) || {};
      defaultRepMax = movement.repMaximum || defaultRepMax;
    }

    // Removed set.load line

    defaultRepMax = Math.round(fromMetric(defaultRepMax, units), 0);
    const precision = units === "metric" ? 2 : 1;
    const load = set.load ? round(fromMetric(set.load, units), precision) : 0;

    const equippedRepMax = fromMetric(set.equippedRepMax);
    let exerciseName;
    switch (activeExercise.type) {
      case "primary":
        exerciseName = `${activeExercise.primary}`;
        break;
      case "secondary":
        exerciseName = `${activeExercise.primary} ${
          activeExercise.secondary ? "(" + activeExercise.secondary + ")" : ""
        }`;
        break;
      case "assistant":
        exerciseName = `${activeExercise.secondary}`;
        break;
    }

    let tabIndex = 100;
    const hasLoad = Boolean(load);
    // setting the variable for the zone, so that subsequent calls are easier to understand.
    const currentZone = fromIntensity(set.percentRepMax, set.reps);
    const exId = activeExercise._id;
    const handleDeleteSet = (e) => {
      e.preventDefault();
      submit(
        `/actions/exercise/quick-edit/sets/remove/${setIndex}/${exId}/${undefined}/${activeUser._id}`
      );
    };
    // used to select the first field when adding set
    const handleFocus = (e) => {
      e.target.select();
    };

    // Setting conditional size for Select's Select-Menu
    let selectorLength = "";
    if (setLength === 1) selectorLength = "xtrashort-list";
    else if (setLength === 2) selectorLength = "short-list";
    else if (setLength === 3) selectorLength = "medium-list";
    else if (setLength === 4) selectorLength = "long-list";
    else selectorLength = "xtralong-list";

    // handling the options for the select
    let movementOptions = [];
    const populateMovementOptions = (primaryString, currentPrimary) => {
      const formattedMovement =
        primaryString.charAt(0).toUpperCase() + primaryString.slice(1);
      const movementPrimaryRepMax = get(
        activeExercise,
        `repMaximums.${primaryString}`
      );

      if (primaryString !== "assistant") {
        movementOptions.push({
          movement: primaryString,
          customizedRM: undefined,
          repMaximum: movementPrimaryRepMax,
          movementLabel: formattedMovement,
          disabled: primaryString === "assistant",
        });
      }
      currentPrimary.map((item) => {
        if (
          (!activeExercise.parameters && !hasSetsReps(item)) ||
          (!hasSetsReps(activeExercise) && !item.parameters) ||
          (activeExercise.parameters &&
            item.parameters &&
            !isEqual(activeExercise.parameters, item.parameters))
        ) {
          return;
        }

        // The calendar in the Athlete Portal uses the Dashboard Program-Editor
        // In case we are in the dashboard program editor, we can skip checking whats missing from the exericse library
        // as both activeUser.exerciseLibrary and activeContextUser.exerciseLibrary will be the same
        if (activeContextUser._id === activeUser._id) {
          const formatted =
            primaryString === "assistant" ? "" : ` (${formattedMovement})`;

          if (item.customizedRM === true) {
            movementOptions.push({
              movement: item.movement,
              repMaximum: item.repMaximum,
              customizedRM: item.customizedRM,
              movementLabel: item.movement + formatted,
              newPrimary: primaryString,
              parameters: item.parameters,
            });
          } else {
            movementOptions.push({
              movement: item.movement,
              repMaximum: item.repMaximum,
              movementLabel: item.movement + formatted,
              newPrimary: primaryString,
              parameters: item.parameters,
            });
          }
        } else {
          // Since we're iterarting through the coach's exercise library, we need to
          // iterate through the athlere's and get: if they have the current movement and the 1RM if its customized
          const athleteMovement = find(
            activeUser.exerciseLibrary[primaryString],
            (athleteExercise) => {
              return athleteExercise.movement === item.movement;
            }
          );
          const doesAthleteHaveExercise = some(
            activeUser.exerciseLibrary[primaryString],
            (athleteExercise) => athleteExercise.movement !== item.movement
          );
          const formatted =
            primaryString === "assistant" ? "" : ` (${formattedMovement})`;

          if (athleteMovement && athleteMovement.customizedRM) {
            movementOptions.push({
              movement: item.movement,
              repMaximum: athleteMovement.repMaximum,
              customizedRM: athleteMovement.customizedRM,
              movementLabel: item.movement + formatted,
              newPrimary: primaryString,
            });
          } else {
            movementOptions.push({
              movement: item.movement,
              repMaximum: doesAthleteHaveExercise
                ? movementPrimaryRepMax
                : item.repMaximum,
              movementLabel: item.movement + formatted,
              newPrimary: primaryString,
            });
          }
        }
      });
    };

    const { deadlift, bench, squat, assistant } =
      activeContextUser.exerciseLibrary;
    if (activeExercise.primary === "squat") {
      populateMovementOptions("squat", squat);
      populateMovementOptions("deadlift", deadlift);
      populateMovementOptions("bench", bench);
      populateMovementOptions("assistant", assistant);
    } else if (activeExercise.primary === "deadlift") {
      populateMovementOptions("deadlift", deadlift);
      populateMovementOptions("squat", squat);
      populateMovementOptions("bench", bench);
      populateMovementOptions("assistant", assistant);
    } else if (activeExercise.primary === "bench") {
      populateMovementOptions("bench", bench);
      populateMovementOptions("squat", squat);
      populateMovementOptions("deadlift", deadlift);
      populateMovementOptions("assistant", assistant);
    } else if (activeExercise.primary === "assistant") {
      populateMovementOptions("assistant", assistant);
      populateMovementOptions("bench", bench);
      populateMovementOptions("squat", squat);
      populateMovementOptions("deadlift", deadlift);
    }

    // Making filter options more precise
    const customFilterOption = (option, rawInput) => {
      const words = rawInput.split(" ");
      return words.reduce(
        (acc, curr) =>
          acc &&
          option.movementLabel.toLowerCase().includes(curr.toLowerCase()),
        true
      );
    };

    const status =
      moment(moment().subtract(1, "days").utc()).isAfter(
        moment(activeExercise.date).endOf("day").utc()
      ) || set.statusArray
        ? getStatus(set)
        : null;

    const StatusIcon =
      status === "Missed" ? (
        <img className="icon-red" src="/img/svg/exclamation-circle.svg" />
      ) : (
        <img src="/img/new-icons/check-circle.svg" />
      );

    // Calendar day view, any set completed (show actual results)
    if (isAnySetCompleted && !isProgramEditor) {
      const percentRM = set.load ? `${round(set.percentRepMax, 1)}` : "";
      return (
        <ActualResultsComponent
          exercise={activeExercise}
          set={set}
          percentRM={percentRM}
          units={units}
          withWeight={withWeight}
          fromMetric={fromMetric}
          idx={setIndex}
          load={hasLoad && withWeight(load, units)}
          exerciseName={exerciseName}
          prefix={prefix}
          expanded={expanded}
          toggleExpanded={toggleExpanded}
          intensityMeasure={intensityMeasure}
          isRiR={isRiR}
          hideVelocitySettings={hideVelocitySettings}
        />
      );
    }

    return (
      <div>
        {/* This is the exercise line */}
        {setIndex === 0 && (
          <div className={`name-line name ${selectorLength}`}>
            <div className="value-wrapper">
              <div className="value">
                {exerciseName.charAt(0).toUpperCase() + exerciseName.slice(1)}
              </div>
              {isProgramEditor ? (
                <img
                  src="/img/svg/move.svg"
                  className="icon-green drag-icon"
                  alt="drag"
                  height={20}
                  width={20}
                />
              ) : (
                <div className="order-arrows-component">
                  <div className={`move-next ${isLast ? "disabled" : ""}`}>
                    <a
                      href="#_"
                      onClick={isLast ? null : nextHandleReorder}
                      className={isLast ? "deactivate" : ""}
                    >
                      <img src="/img/svg/angle-down.svg" alt="move forward" />
                    </a>
                  </div>
                  <div className={`move-prev ${isFirst ? "disabled" : ""}`}>
                    <a
                      href="#_"
                      onClick={isFirst ? null : prevHandleReorder}
                      className={isFirst ? "deactivate" : ""}
                    >
                      <img src="/img/icons/angle-up.svg" alt="move backward" />
                    </a>
                  </div>
                </div>
              )}
            </div>
            <div className="input">
              <Select
                className="movement-select"
                id="newMovementName"
                name="movementName"
                instanceId="newMovementName"
                matchPos="start"
                valueKey="movementLabel"
                labelKey="movementLabel"
                autosize={false}
                clearable={false}
                value={newMovement}
                options={movementOptions}
                filterOption={customFilterOption}
                onChange={(val) =>
                  _handleNewMovementChange(val, exId, setIndex)
                }
                placeholder={
                  exerciseName.charAt(0).toUpperCase() + exerciseName.slice(1)
                }
              />
            </div>
            <div>
              <div className="parameters-columns">
                {!Array.isArray(activeExercise.parameters) ? (
                  <div className="parameters-container-titles">
                    <div className="parameter-item">
                      {t("exerciseLineItem.sets")}
                    </div>
                    <div className="parameter-item">
                      {t("exerciseLineItem.reps")}
                    </div>
                    <div className="parameter-item">{intensityMeasure}</div>
                    <div className="parameter-item">
                      {t("exerciseLineItem.load")}
                    </div>

                    <div
                      className="parameter-item"
                      style={{
                        opacity: activeExercise.type != "assistant" ? 1 : 0,
                      }}
                    >
                      {t("exerciseLineItem.intensity")}
                    </div>
                    {isQuickEditOpen && (
                      <div className="exercises-column add-delete-set"></div>
                    )}
                    <div className="parameter-item parameter-status">
                      {t("exerciseLineItem.status")}
                    </div>
                  </div>
                ) : (
                  <div
                    className={`parameters-container-titles ${
                      activeExercise.parameters[0] === FREEFORM
                        ? "freeform"
                        : ""
                    }`}
                  >
                    {Array.from({ length: 5 }, (x, i) =>
                      activeExercise.parameters[i] === FREEFORM ? null : (
                        <div className="parameter-item">
                          {[RPE, RPEAMRAP].includes(
                            parameterName(activeExercise.parameters[i])
                          )
                            ? intensityMeasure
                            : parameterName(activeExercise.parameters[i])}
                        </div>
                      )
                    )}
                    {isQuickEditOpen && (
                      <div className="exercises-column add-delete-set"></div>
                    )}
                    <div className="parameter-item parameter-status">
                      {t("exerciseLineItem.status")}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
        {setIndex === 0 && (
          <AthleteExerciseNote note={activeExercise.athleteNotes} />
        )}
        {setIndex != 0 && <div className="exercises-name" />}
        <div className="line">
          <div
            className={`parameters-column-pb ${
              !isQuickEditOpen && isProgramEditor && "dashboard-pb"
            }`}
          >
            {Array.isArray(activeExercise.parameters) ? (
              <div className="container-line">
                {Array.from(
                  {
                    length: activeExercise.parameters[0] === FREEFORM ? 1 : 5,
                  },
                  (x, index) => {
                    const elem = activeExercise.parameters[index];
                    return !elem ? (
                      <div className="parameter-item"></div>
                    ) : (
                      <div
                        className={`${
                          elem === FREEFORM
                            ? "parameter-item-freeform"
                            : "parameter-item"
                        }`}
                        key={`${index}_${elem}_parameter_${setLength}_${
                          set[mapParameter(elem)]
                        }`}
                        id={`${index}_${elem}_parameter`}
                      >
                        <div className="value">
                          {elem === LOAD
                            ? set[mapParameter(elem)]
                              ? withWeight(
                                  units === "imperial"
                                    ? convert(set[mapParameter(elem)])
                                        .from("kg")
                                        .to("lb")
                                    : set[mapParameter(elem)]
                                )
                              : null
                            : [RPE, RPEAMRAP].includes(elem)
                              ? convertToRiR(set[mapParameter(elem)], !isRiR)
                              : elem === REPS
                                ? repsValue(set.reps, set.repsLower)
                                : set[mapParameter(elem)]}
                        </div>
                        <div className="input">
                          <ParameterQuickEditInput
                            id={`${exId}_${setIndex}_${elem.toLowerCase()}`}
                            name={mapParameter(elem)}
                            defaultValue={
                              elem === REPS
                                ? repsValue(set.reps, set.repsLower)
                                : set[mapParameter(elem)]
                            }
                            onInput={(e) =>
                              handleQuickEditChange(e, exId, setIndex)
                            }
                            parameter={elem}
                            onChange={(e) => {
                              if (
                                e &&
                                (e.target.value || e.target.value === "")
                              ) {
                                const value = e.target.value;
                                handleQuickEditChange(e, exId, setIndex);

                                setTimeout(() => {
                                  if (
                                    value === "AMRAP" &&
                                    document.getElementById(
                                      `${exId}_${setIndex}_reps`
                                    ).value === ""
                                  ) {
                                    handleQuickEditChange(
                                      { target: { name: "reps", value: 0 } },
                                      exId,
                                      setIndex
                                    );
                                  }
                                }, 500);
                              }
                            }}
                            key={`${exId}_${setIndex}_rpe_${set.rpe}`}
                            keyParam={`${exId}_${setIndex}_${elem.toLowerCase()}`}
                            units={units}
                            intensityMeasure={intensityMeasure}
                            isRiR={isRiR}
                          />
                        </div>
                      </div>
                    );
                  }
                )}
                {isQuickEditOpen && (
                  <div className="exercises-column add-delete-set">
                    <div className="input">
                      <ToolTip
                        id="delete-set"
                        body={t("exerciseLineItem.deleteSet")}
                      >
                        <a
                          className="remove"
                          onClick={(e) => handleDeleteSet(e)}
                          href="#_"
                        >
                          <img
                            className="icon-red"
                            src="/img/svg/delete-set-red.svg"
                            alt={t("common:remove")}
                          />
                        </a>
                      </ToolTip>
                    </div>
                    <div className="input">
                      <ToolTip id="add-set" body={t("exerciseLineItem.addSet")}>
                        <a
                          className="add-set"
                          onClick={(e) => _handleOpenAddSet(e, setIndex)}
                          href="#_"
                        >
                          <img
                            className="icon-green"
                            src="/img/icons/add-set-icon-2.svg"
                            alt={t("common:add")}
                          />
                        </a>
                      </ToolTip>
                    </div>
                  </div>
                )}
                {!isProgramEditor && (
                  <div className="parameter-item parameter-status">
                    {status && (
                      <div
                        className={`value ${
                          status === "Missed" ? "missed" : "completed"
                        }`}
                      >
                        {StatusIcon}
                      </div>
                    )}
                  </div>
                )}
              </div>
            ) : (
              <div className="container-line">
                <div className="exercises-column sets">
                  <div className="value">{set.sets}</div>
                  <div className="input">
                    <input
                      id={`${exId}_${setIndex}_sets`}
                      name="sets"
                      defaultValue={set.sets}
                      onInput={(e) =>
                        e &&
                        e.target.value &&
                        handleQuickEditChange(e, exId, setIndex)
                      }
                      className="text-input"
                      type="number"
                      step="1"
                    />
                  </div>
                </div>
                <div className="exercises-column reps">
                  <div className="value">
                    {repsValue(set.reps, set.repsLower)}
                  </div>
                  <div className="input">
                    <input
                      id={`${exId}_${setIndex}_reps`}
                      name="reps"
                      defaultValue={repsValue(set.reps, set.repsLower)}
                      onInput={(e) =>
                        e &&
                        (e.target.value ||
                          (set.rpe === "AMRAP" && e.target.value === "")) &&
                        handleQuickEditChange(e, exId, setIndex)
                      }
                      className="text-input"
                      type="text"
                    />
                  </div>
                </div>
                <div className="exercises-column rpe">
                  <div className="value">
                    {convertToRiR(set.rpe, !isRiR)}
                  </div>
                  <div className="input">
                    <select
                      id={`${exId}_${setIndex}_rpe`}
                      key={`${exId}_${setIndex}_rpe_${set.rpe}`}
                      className="select-input"
                      name="rpe"
                      defaultValue={set.rpe}
                      onChange={(e) => {
                        if (e && (e.target.value || e.target.value === "")) {
                          const value = e.target.value;
                          handleQuickEditChange(e, exId, setIndex);

                          setTimeout(() => {
                            if (
                              value === "AMRAP" &&
                              document.getElementById(
                                `${exId}_${setIndex}_reps`
                              ).value === ""
                            ) {
                              handleQuickEditChange(
                                { target: { name: "reps", value: 0 } },
                                exId,
                                setIndex
                              );
                            }
                          }, 500);
                        }
                      }}
                    >
                      <option value="">{intensityMeasure}</option>

                      {map(range(4, 9.5, 0.5), (i) => (
                        <option key={i} value={i + 1}>
                          {convertToRiR(i + 1, !isRiR)}
                        </option>
                      ))}
                      <option value="AMRAP">AMRAP</option>
                    </select>
                  </div>
                </div>
                <div className="exercises-column load">
                  <div className="value">
                    {hasLoad && withWeight(load, units)}
                  </div>
                  <div className="input">
                    <div
                      className={`container-input ${
                        units === "metric"
                          ? "container-metric"
                          : "container-imperial"
                      }`}
                    >
                      <input
                        id={`${exId}_${setIndex}_load`}
                        name="load"
                        defaultValue={load}
                        onInput={(e) =>
                          e &&
                          (e.target.value || e.target.value === "") &&
                          handleQuickEditChange(e, exId, setIndex)
                        }
                        className="text-input"
                        type="number"
                        step=".1"
                        ref={(input) =>
                          loadInputs
                            ? (loadInputs[`${exId}_${setIndex}`] = input)
                            : null
                        }
                      />
                    </div>
                  </div>
                </div>
                {!isAssistant && (
                  <div className="exercises-column intensity">
                    <span
                      className={
                        !isQuickEditOpen
                          ? `zone-dot zone-intensity ${currentZone}`
                          : "center-intensity"
                      }
                      style={!hasLoad ? { borderBottomWidth: 0 } : {}}
                    >
                      <div
                        className="value"
                        style={{ color: "var(--white-87)" }}
                      >
                        {set.load ? `${round(set.percentRepMax, 1)}%` : ""}
                        &nbsp;
                      </div>
                      <div className="container-input container-intensity">
                        <input
                          id={`${exId}_${setIndex}_percentRepMax`}
                          name="percentRepMax"
                          defaultValue={
                            set.percentRepMax ? round(set.percentRepMax, 1) : 0
                          }
                          onChange={(e) =>
                            e &&
                            e.target.value &&
                            handleQuickEditChange(e, exId, setIndex)
                          }
                          className="text-input"
                          type="number"
                          step=".1"
                          ref={(input) =>
                            intensityInputs
                              ? (intensityInputs[`${exId}_${setIndex}`] = input)
                              : null
                          }
                          style={{ paddingRight: "15px" }}
                        />
                      </div>
                    </span>
                  </div>
                )}
                {!!isAssistant && (
                  <div className="exercises-column intensity" />
                )}
                {isQuickEditOpen && (
                  <div className="exercises-column add-delete-set">
                    <div className="input">
                      <ToolTip
                        id="delete-set"
                        body={t("exerciseLineItem.deleteSet")}
                      >
                        <a
                          className="remove"
                          onClick={(e) => handleDeleteSet(e)}
                          href="#_"
                        >
                          <img
                            className="icon-red"
                            src="/img/svg/delete-set-red.svg"
                            alt={t("common:remove")}
                          />
                        </a>
                      </ToolTip>
                    </div>
                    <div className="input">
                      <ToolTip id="add-set" body={t("exerciseLineItem.addSet")}>
                        <a
                          className="add-set"
                          onClick={(e) => _handleOpenAddSet(e, setIndex)}
                          href="#_"
                        >
                          <img
                            className="icon-green"
                            src="/img/icons/add-set-icon-2.svg"
                            alt={t("common:add")}
                          />
                        </a>
                      </ToolTip>
                    </div>
                  </div>
                )}
                {!isProgramEditor && (
                  <div className="exercises-column status">
                    {status && (
                      <div
                        className={`value ${
                          status === "Missed" ? "missed" : "completed"
                        }`}
                      >
                        {StatusIcon}
                      </div>
                    )}
                  </div>
                )}
              </div>
            )}
          </div>

          {!!set.equipped && (
            <div className="equipped">
              <span>
                <b>{t("exerciseLineItem.equipped")}</b> {set.equipment || ""}
              </span>
              <span>
                <b>{t("exerciseLineItem.rm")}</b>{" "}
                {withWeight(equippedRepMax, units)}
              </span>
            </div>
          )}
        </div>

        {isQuickEditOpen &&
          isAddingSet &&
          currentRow === setIndex &&
          (Array.isArray(activeExercise.parameters) ? (
            <NewExerciseLineParameters
              newSet={newSet}
              setIndex={setIndex}
              _handleNewSetChange={_handleNewSetChange}
              exId={exId}
              activeExercise={activeExercise}
              activeUser={activeUser}
              _handleCloseAddSet={_handleCloseAddSet}
              _handleSaveNewSetForOther={_handleSaveNewSetForOther}
            />
          ) : (
            <div className="line add-set">
              <div className="parameters-column-pb">
                <div className="container-line">
                  <div className="exercises-column sets">
                    <div className="value">{newSet.sets}</div>
                    <input
                      autoFocus
                      id={`new_${exId}_${setIndex}_sets`}
                      name="sets"
                      type="number"
                      tabIndex={tabIndex++}
                      defaultValue={newSet.sets}
                      onFocus={(e) => handleFocus(e)}
                      onInput={(e) =>
                        e &&
                        e.target.value &&
                        _handleNewSetChange(e, defaultRepMax)
                      }
                      className="text-input"
                      step="1"
                    />
                  </div>
                  <div className="exercises-column reps">
                    <div className="value">{newSet.reps}</div>
                    <input
                      id={`new_${exId}_${setIndex}_reps`}
                      name="reps"
                      type="text"
                      tabIndex={tabIndex++}
                      defaultValue={newSet.reps}
                      onInput={(e) =>
                        e &&
                        e.target.value &&
                        _handleNewSetChange(e, defaultRepMax)
                      }
                      className="text-input"
                    />
                  </div>
                  <div className="exercises-column rpe">
                    <select
                      id={`new_${exId}_${setIndex}_rpe`}
                      name="rpe"
                      tabIndex={tabIndex++}
                      className="select-input"
                      defaultValue={newSet.rpe}
                      onChange={(e) =>
                        e &&
                        e.target.value &&
                        _handleNewSetChange(e, defaultRepMax)
                      }
                    >
                      <option value="">{intensityMeasure}</option>
                      {map(range(4, 9.5, 0.5), (i) => (
                        <option key={i} value={i + 1}>
                          {convertToRiR(i + 1, !isRiR)}
                        </option>
                      ))}
                      <option value="AMRAP">AMRAP</option>
                    </select>
                  </div>
                  <div className="exercises-column load">
                    <div className="value">{newSet.load}</div>
                    <div className="input">
                      <div
                        className={`container-input ${
                          units === "metric"
                            ? "container-metric"
                            : "container-imperial"
                        }`}
                      >
                        <input
                          id={`new_${exId}_${setIndex}_load`}
                          name="load"
                          type="number"
                          tabIndex={tabIndex++}
                          defaultValue={newSet.load}
                          onInput={(e) =>
                            e &&
                            e.target.value &&
                            _handleNewSetChange(e, defaultRepMax)
                          }
                          className="text-input"
                          step=".1"
                          ref={(input) =>
                            localLoadInputs
                              ? (localLoadInputs["new"] = input)
                              : null
                          }
                        />
                      </div>
                    </div>
                  </div>
                  {!isAssistant && (
                    <div className="exercises-column intensity">
                      <span className="center-intensity">
                        <div className="value">{newSet.percentRepMax}</div>
                        <div className="container-input container-intensity">
                          <input
                            id={`new_${exId}_${setIndex}_percentRepMax`}
                            name="percentRepMax"
                            type="number"
                            tabIndex={tabIndex++}
                            defaultValue={newSet.percentRepMax}
                            onChange={(e) =>
                              e &&
                              e.target.value &&
                              _handleNewSetChange(e, defaultRepMax)
                            }
                            className="text-input"
                            step=".1"
                            ref={(input) =>
                              localIntensityInputs
                                ? (localIntensityInputs["new"] = input)
                                : null
                            }
                          />
                        </div>
                      </span>
                    </div>
                  )}
                  {!!isAssistant && (
                    <div className="exercises-column intensity" />
                  )}

                  {/* Save and Cancel Buttons */}
                  <div className="exercises-column add-delete-set">
                    <ToolTip
                      id="delete-set"
                      body={t("exerciseLineItem.deleteSet")}
                    >
                      <a onClick={(e) => _handleCloseAddSet(e)} href="#_">
                        <img
                          className="icon-red"
                          src="/img/svg/close-circle.svg"
                          alt="cancel-set"
                        />
                      </a>
                    </ToolTip>
                    <ToolTip id="add-set" body={t("exerciseLineItem.addSet")}>
                      <a
                        type="submit"
                        tabIndex={tabIndex++}
                        onClick={(e) =>
                          _handleSaveNewSet(
                            e,
                            set.equipped,
                            defaultRepMax,
                            activeUser,
                            exId,
                            setIndex
                          )
                        }
                        href="#_"
                      >
                        <img
                          className="icon-yellow icon-lg"
                          src="/img/new-icons/check-circle.svg"
                          alt="save-set"
                        />
                      </a>
                    </ToolTip>
                  </div>
                  <div className="exercises-column status"></div>
                </div>
              </div>
            </div>
          ))}
      </div>
    );
  }
}

export default withTranslation("dashboard")(ExerciseLineItem);
